import { render, staticRenderFns } from "./RateCategoryList.vue?vue&type=template&id=10c8957d"
import script from "./RateCategoryList.vue?vue&type=script&lang=js"
export * from "./RateCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports